<div class="pb-2">
    <kendo-tabstrip class="formly-tab-background-white pl-3 mr-1 mt-3 mb-1" [class]="to.className">
        <ng-container *ngFor="let tab of field.fieldGroup; let i=index;">
            <kendo-tabstrip-tab title="{{ tab.templateOptions.label }}" [selected]="i === 0"
                style="background-color:#fff">
                <ng-template kendoTabContent>
                    <div class="m-3">
                        <formly-field [field]="tab"></formly-field>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </ng-container>
    </kendo-tabstrip>
</div>